export default "__VITE_ASSET__DJiggehv__"